import React, { useState } from "react";
import { Drawer, Row, Col, message } from "antd";
import Keyboard from "react-simple-keyboard";
import TextArea from "antd/lib/input/TextArea";
import Close from "../../../../assets/images/close-x.svg";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";

const ItemNotesDrawer = ({
  notesPopup,
  setNotesPopup,
  notesValue,
  setNotesValue,
  selectedItem,
  setSelectedItem,
  setInstructions,
  cart,
  setCart,
  // Optional: when provided, Enter/Clear use this callback instead of cart update
  onConfirm,
  title,
}) => {
  const [layoutName, setLayoutName] = useState("default");
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  // TSK-3303: item notes are an item-level modification — block edits once Prepare
  // Bill has confirmed the order, unless the till explicitly allows them.
  const isNotesEditBlocked = () => {
    if (cart?.preparedBillOrigin === "Y" && posConfig?.allowModificationAfterPrepareBill !== "Y") {
      message.info("Bill is already prepared. Item modifications are not allowed.");
      return true;
    }
    return false;
  };

  const handleShift = () => {
    setLayoutName((prev) => (prev === "default" ? "shift" : "default"));
  };

  return (
    <Drawer
      placement="bottom"
      height="53vh"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            {title || "Add Notes for Item"}
          </p>
          <img
            src={Close}
            onClick={() => {
              setNotesPopup(false);
              setNotesValue("");
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      closeIcon={null}
      className="filter"
      styles={{ body: { paddingTop: 0 } }}
      open={notesPopup}
      closable={true}
      onClose={() => {
        setNotesPopup(false);
      }}
      footer={null}
    >
      <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
        <Col
          span={11}
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <TextArea
            id="notes-input"
            style={{ resize: "none" }}
            maxLength={200}
            onChange={(e) => setNotesValue(e.target.value)}
            value={notesValue}
            rows={9}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "8px",
            }}
          >
            <span
              style={{
                fontFamily: "Inter",
                fontSize: "0.8em",
                color: "#929098",
                fontWeight: 500,
              }}
            >
              Max Characters : 200
            </span>
            <span
              style={{
                color: "#929098",
                textDecoration: "underline",
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: "0.8em",
                fontWeight: 500,
              }}
              onClick={() => {
                if (!onConfirm && isNotesEditBlocked()) return;
                setNotesValue("");
                if (onConfirm) {
                  onConfirm("");
                } else {
                  const updatedCartItems = cart.items.map((cartItem) =>
                    cartItem.id === selectedItem.id ? { ...cartItem, notes: "" } : cartItem
                  );
                  setCart({ ...cart, items: updatedCartItems });
                  if (selectedItem) {
                    setSelectedItem({ ...selectedItem, notes: "" });
                  }
                  setNotesPopup(false);
                }
              }}
            >
              Clear Notes
            </span>
          </div>
        </Col>

        <Col span={12} offset={1}>
          <Keyboard
            theme={"hg-theme-default aprvl"}
            onKeyPress={(button) => {
              if (button === "{backspace}") {
                setNotesValue((prev) => prev.slice(0, -1));
              } else if (button === "{space}") {
                setNotesValue((prev) => prev + " ");
              } else if (button === "{shift}" || button === "{lock}") {
                handleShift();
              } else if (button === "{number}") {
                setLayoutName("number");
              } else if (button === "{numbers}") {
                setLayoutName("numbers");
              } else if (button === "{small}") {
                setLayoutName("shift");
              } else if (button === "{caps}") {
                setLayoutName("default");
              } else if (button === "{enter}") {
                if (onConfirm) {
                  onConfirm(notesValue);
                } else if (selectedItem) {
                  if (isNotesEditBlocked()) return;
                  const updatedCartItems = cart.items.map((cartItem) =>
                    cartItem.lineId === selectedItem.lineId
                      ? { ...cartItem, notes: notesValue }
                      : cartItem
                  );
                  setCart({ ...cart, items: updatedCartItems });
                  selectedItem.notes = notesValue;
                  setInstructions(notesValue);
                  setNotesPopup(false);
                }
              } else {
                setNotesValue((prev) => prev + button);
              }
            }}
            layoutName={layoutName}
            display={{
              "{abc}": "ABC",
              "{smileys}": "\uD83D\uDE03",
              "{back}": "Enter",
              "{numbers}": "123",
              "{number}": "123",
              "{bksp}": "backspace",
              "{backspace}": "⌫",
              "{shift}": "⇧",
              "{tab}": "tab",
              "{lock}": "lock",
              "{enter}": "Enter",
              "{space}": "Space",
              "{caps}": "ABC",
              "{small}": "abc",
            }}
            layout={
              posConfig?.keyboardLanguage === "Y" && posConfig?.selectedKeyboardLanguage === "ar"
                ? {
                    shift: ["ض ص ث ق ف غ ع ه خ ح ج د", "ش س ي ب ل ا ت ن م ك ط", "{shift} ئ ء ؤ ر ى ة و ز ظ أ إ آ ـ {backspace}", "{number} {space} {enter}"],
                    numbers: ["١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠", "! @ # $ % ^ & * ( )", "- . ، _ / ؛ ؟ {backspace}", "{caps} {space} {enter}"],
                    number: ["١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠", "! @ # $ % ^ & * ( )", "- . ، _ / ؛ ؟ {backspace}", "{small} {space} {enter}"],
                    default: ["ض ص ث ق ف غ ع ه خ ح ج د", "ش س ي ب ل ا ت ن م ك ط", "{shift} ئ ء ؤ ر ى ة و ز ظ أ إ آ ـ {backspace}", "{numbers} {space} {enter}"],
                  }
                : {
                    shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                    numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                    number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                    default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                  }
            }
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default ItemNotesDrawer;
